import {
  CreateMessageTemplateRequest,
  UpdateMessageTemplateRequest,
} from '@act/shared/types';
import { EndpointDefinition } from '../utils/endpoint-definition';
import type {
  CreateMessageTemplateCategoryDto,
  MessageTemplateAdminDto,
  MessageTemplateCategoryAdminDto,
  MessageTemplateCategoryDto,
  UpdateMessageTemplateCategoryDto,
} from '@act/shared/data-transfer-objects';

export const messageTemplatesRequests = {
  getMessageTemplateCategories: EndpointDefinition.get<
    MessageTemplateCategoryDto[],
    null
  >({
    name: 'getMessageCategories',
    route: '/chat/messages/templates',
  }),
  createMessageTemplateCategory: EndpointDefinition.post<
    MessageTemplateCategoryAdminDto,
    CreateMessageTemplateCategoryDto,
    null
  >({
    name: 'createTemplateCategory',
    route: '/chat/messages/templates/categories',
  }),
  updateMessageTemplateCategory: EndpointDefinition.patch<
    MessageTemplateCategoryAdminDto,
    UpdateMessageTemplateCategoryDto,
    { id: number }
  >({
    name: 'updateTemplateCategory',
    route: '/chat/messages/templates/category/:id',
  }),
  createMessageTemplate: EndpointDefinition.post<
    MessageTemplateAdminDto,
    CreateMessageTemplateRequest,
    null
  >({
    name: 'createMessageTemplate',
    route: '/chat/messages/templates',
  }),
  updateMessageTemplate: EndpointDefinition.patch<
    MessageTemplateAdminDto,
    UpdateMessageTemplateRequest,
    { id: number }
  >({
    name: 'updateMessageTemplate',
    route: '/chat/messages/templates/:id',
  }),
};
